<template>
    <div class="activity-content auto-rebalance-failed">
        <div class="activity-header">
            <span class="material-icons error-icon">error_outline</span>
            <div class="activity-title">Otomatik Bakiye Yükleme Başarısız</div>
        </div>
        <div class="activity-details">
            <div class="detail-item">
                <span class="label">Hata:</span>
                <span class="value error">{{ activity.payload.error }}</span>
            </div>
            <div class="detail-item">
                <span class="label">Deneme:</span>
                <span class="value">{{ activity.payload.failedAttempts }}/{{ activity.payload.maxFailedAttempts }}</span>
            </div>
            <div class="detail-item">
                <span class="label">Eşik Değer:</span>
                <span class="value">{{ formatPrice(activity.payload.threshold) }} TL</span>
            </div>
            <div class="detail-item">
                <span class="label">Hedef Bakiye:</span>
                <span class="value">{{ formatPrice(activity.payload.upTo) }} TL</span>
            </div>
        </div>
        <div class="activity-footer">
            <span class="warning-text">
                <span class="material-icons">info</span>
                Sistem otomatik olarak tekrar deneyecek. Sorun devam ederse destek ile iletişime geçin.
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "AutoRebalanceFailed",
    props: {
        activity: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatPrice(price) {
            if (!price) return "0.00";
            return price.toFixed(2);
        },
    },
};
</script>

<style scoped lang="scss">
.auto-rebalance-failed {
    .activity-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .error-icon {
            color: #ff4d4f;
            font-size: 20px;
        }

        .activity-title {
            font-weight: 600;
            color: #ff4d4f;
            font-size: 14px;
        }
    }

    .activity-details {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding-left: 28px;
        margin-bottom: 12px;

        .detail-item {
            display: flex;
            justify-content: space-between;
            font-size: 13px;

            .label {
                color: #666;
            }

            .value {
                font-weight: 500;
                color: #333;

                &.error {
                    color: #ff4d4f;
                    font-weight: 600;
                }
            }
        }
    }

    .activity-footer {
        padding-left: 28px;

        .warning-text {
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: #faad14;
            background: #fffbe6;
            padding: 8px 12px;
            border-radius: 4px;
            border: 1px solid #ffe58f;

            .material-icons {
                font-size: 16px;
            }
        }
    }
}
</style>
